<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <div className="animated">
            <b-card header-tag="header" footer-tag="footer">
              <div align="left" @click="goBack"><b-link>Atras</b-link></div>

              <h1>Evaluaciones Recepcion Lote {{ NumLot }}</h1>
              <v-server-table
                :url="url"
                :columns="columns"
                :options="options"
                :theme="theme"
                ref="table"
                id="dataTable"
                style="text-align: center"
              >
                <div slot="beforeLimit">
                  <download-excel
                    class="btn"
                    :fetch="fetchData"
                    :before-generate="startDownload"
                    :before-finish="finishDownload"
                  >
                    <b-link>Descargar</b-link>
                  </download-excel>
                </div>

                <template slot="Evaluacion" slot-scope="props">
                  {{ props.row.index }}
                </template>

                <template slot="afterFilter">
                  <tr v-if="loading" class="VueTables__no-results">
                    <b-spinner
                      v-if="loading"
                      variant="primary"
                      class="ml-2 mt-1"
                      small
                      label="Small Spinner"
                    ></b-spinner>
                  </tr>
                </template>

                <template slot="resultado" slot-scope="props">
                  <b-badge href="" :style="'color:white;background-color:' + props.row._color">{{
                    props.row.clasification
                  }}</b-badge>
                </template>

                <template slot="fecha" slot-scope="props">
                  {{ formatDate(props.row.created_at) }}
                </template>

                <div class="text-right" slot="actions" slot-scope="props">
                  <div style="text-align: center">
                    <a
                      target="_blank"
                      href="#"
                      @click.prevent="showDetailedInspection(props.row)"
                      class="fa fa-lg fa fa-search text-black-50"
                      title="Detalle de inspecciones"
                    ></a
                    >&nbsp;
                    <a
                      href="#"
                      @click.prevent="showReportQc(props.row)"
                      class="fa fa-lg fa fa-file-excel-o text-black-50"
                      title="informe Castaña"
                    ></a
                    >&nbsp;
                    <a
                      target="_blank"
                      href="#"
                      @click.prevent="showFormMailModal(props.row)"
                      class="fa fa-lg fa fa-send text-black-50"
                      title="Enviar informe Castaña"
                    ></a
                    >&nbsp;
                  </div>
                </div>
              </v-server-table>
            </b-card>
          </div>
        </b-col>
      </b-row>
    </div>

    <b-modal v-model="modalShown" centered size="lg" :title="titleModal" hide-footer>
      <component :is="componenteActual" :objReportQc="objReportQc" :ref="report"> </component>
    </b-modal>
  </div>
</template>

<script>
import Vue from "vue";
import { ServerTable, Event } from "vue-tables-2";
import JsonExcel from "vue-json-excel";
import moment from "moment";
import FormEmailQC from "./FormMailCastana.vue";

window.axios = require("axios");

Vue.component("downloadExcel", JsonExcel);

Vue.use(ServerTable);

export default {
  name: "ListIEvaluacionReception",
  components: {
    ServerTable
  },
  mounted() {
    Event.$on("vue-tables.loading", () => {
      this.loading = true;
    });

    Event.$on("vue-tables.loaded", () => {
      this.loading = false;
    });
  },
  props: ["NumLot", "LotID", "typeInspectionID", "typeNameTypeInspection", "inspection_data_id"],
  data() {
    return {
      loading: false,
      modalShown: false,
      componenteActual: "",
      report: "",
      titleModal: "",
      objReportQc: {},
      DirLaravel: localStorage.getItem("qc_api_url"),
      //DirLaravel:"http://localhost/packingonline/public/",
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8"
          }
        ]
      ],
      columns: [
        "Evaluacion",
        "lot.number",
        "lot.waybill",
        "lot.origin",
        "lot.product_name",
        "lot.variety",
        "fecha",
        "actions"
      ],

      data: [],
      useVuex: false,
      theme: "bootstrap4",
      template: "default",
      options: {
        responseAdapter: function (resp) {
          const results = resp.data.results;
          const items = [];
          let index = 1;
          for (let key in results) {
            const item = results[key];
            const returnedTarget = Object.assign(item, { index: index });
            items.push(returnedTarget);
            index++;
          }

          return {
            data: items,
            count: resp.data.count
          };
        },
        texts: {
          noResults: "No se encontraron registros.",
          filter: "Filtrar:",
          filterBy: "Filtrar por {column}",
          count: " ",
          filterPlaceholder: "Buscar...",
          columns: "Columnas",
          limit: "Registros:"
        },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        debounce: 700,
        // columnsDropdown: true,
        filterByColumn: false,
        headings: {
          "lot.number": "Lote",
          "lot.waybill": "Guia",
          "lot.origin": "Productor",
          "lot.product_name": "Producto",
          "lot.variety": "Variedad",
          actions: "Acciones"
        },

        sortable: [],
        sortIcon: { base: "fa", up: "fa-sort-asc", down: "fa-sort-desc", is: "fa-sort" },
        pagination: {
          dropdown: false,
          chunk: 10
        }
      }
    };
  },
  computed: {
    url() {
      return (
        "/api/qc/lotqc/detail_qc_evaluation/?" +
        "id_lot=" +
        this.LotID +
        "&type_inspection_id=" +
        this.typeInspectionID +
        "&inspection_data_id=" +
        this.inspection_data_id
      );
    }
  },
  methods: {
    async fetchData() {
      const response = await this.$axios.get(
        "/api/qc/lotqc/detail_qc_evaluation/?" +
          "id_lot=" +
          this.LotID +
          "&type_inspection_id=" +
          this.typeInspectionID +
          "&inspection_data_id=" +
          this.inspection_data_id
      );

      return response.data.results;
    },
    startDownload() {
      this.loading = true;
    },
    finishDownload() {
      this.loading = false;
    },
    forceFileDownload(response, a) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "Packing List - Embarque #" + a + ".xlsx"); //or any other extension
      document.body.appendChild(link);
      link.click();
    },
    showDetailedInspection(a) {
      this.$router.push(
        "/calidad/detailed-lot-inspection/" +
          a.lot_id +
          "/" +
          a.lot.number +
          "/" +
          a.inspection_type +
          "/" +
          a.inspection_type_name +
          "/" +
          a.inspection_data_id +
          "/" +
          a.index
      );
    },
    showReportQc(a) {
      window.open(
        this.DirLaravel + "controlcalidad/informe_qc_castana/" + a.lot_id + "/1/" + a.inspection_data_id,
        "_blank",
        ""
      );
    },

    formatDate: function (date) {
      return moment(date).format("DD-MM-YYYY HH:MM:SS");
    },
    onComplete() {},
    showFormMailModal(a) {
      this.titleModal = "Enviar informe de castaña";

      this.modalShown = true;
      this.objReportQc = a;

      this.componenteActual = FormEmailQC;

      this.report = "report";
      this.$nextTick(function () {});
    },
    goBack() {
      this.$router.go(-1);
    }
  },
  beforeMount() {}
};
</script>

<style>
#dataTable {
  width: 100%;
  margin: 0 auto;

  .VuePagination {
    text-align: center;
    justify-content: center;
  }

  .table td {
    padding: 0.3em;
  }

  .vue-title {
    text-align: center;
    margin-bottom: 10px;
  }

  .VueTables__search-field {
    display: flex;
  }
  .VueTables__search-field input {
    margin-left: 0.12rem;
  }

  .VueTables__limit-field {
    display: flex;
  }

  .VueTables__limit-field select {
    margin-left: 0.25rem !important;
  }

  .VueTables__table th {
    text-align: center;
  }

  .VueTables__child-row-toggler {
    width: 16px;
    height: 16px;
    line-height: 16px;
    display: block;
    margin: auto;
    text-align: center;
  }

  .VueTables__child-row-toggler--closed::before {
    content: "+";
  }
  .VueTables__date-filter {
    border: 1px solid #ccc;
    padding: 6px;
    border-radius: 4px;
    cursor: pointer;
  }
  .VueTables__number-field {
    border: 4px solid #ccc;
    padding: 6px;
    border-radius: 4px;
    cursor: pointer;
  }
  .VueTables__child-row-toggler--open::before {
    content: "-";
  }
}
</style>
